const lists = [
    [
        "Found in the trash:",
        "Removed because of sanitation constructions:",
        "You will never believe what i have found:",
        "Vegan yoga instructor is looking for:",
        "Woman (50, but looks like 35) is looking for:",
        "Cheaper then ever!",
        "Kill all rodents, cockroaches and other filthy animals with:",
        "Alcholic (32) wants to get of the booze and is looking for:"
    ],
    [
        "5000 stackable and foldable chairs.",
        "A kinky self-published novella.",
        "'The truth according to the Dalai Lama'.",
        "A confused elderly gentlemen (my uncle-in-law).",
        "'Molly' (1 year), black with white spots, very kind.",
        "A manilla folder containing erotic photographs.",
        "Someone who can give a Thai massage (no sex).",
        "A second-hand laptop running Windows XP.",
    ],
    [
        "Free, but to trade for 'hospitality'.",
        "As seen on television!",
        "Sweet for children, but can't be left alone.",
        "Ideal for a day at the beach!",
        "Cheaper than ever because of the pandemic!",
        "With brushy hair on arms, legs and back.",
        "Ment for two persons, but can also fit three.",
        "Near several pools, unfortunately all closed."
    ]
];

export default {
    "lists" : lists.map((l) => {
        return { "text" : l.join('\n') };
    })
};